// @ts-nocheck
/**
 * Scale a authored fontSize relative to the item's original canvas size.
 *
 * relSz = min(width/orgWidth, height/orgHeight)
 * fontSize = setFontSize * relSz
 *
 * When org dims are unset/invalid (≤ 0), treat org as current size → relSz = 1.
 */
export function computeScaledFontSize(
  fontSize: number,
  width: number,
  height: number,
  orgWidth: number | undefined | null,
  orgHeight: number | undefined | null,
): number {
  if (!Number.isFinite(fontSize)) {
    return fontSize;
  }
  const orgW = typeof orgWidth === 'number' && orgWidth > 0 ? orgWidth : width;
  const orgH = typeof orgHeight === 'number' && orgHeight > 0 ? orgHeight : height;
  if (!(orgW > 0) || !(orgH > 0) || !Number.isFinite(width) || !Number.isFinite(height)) {
    return fontSize;
  }
  const relSz = Math.min(width / orgW, height / orgH);
  if (!Number.isFinite(relSz) || relSz <= 0) {
    return fontSize;
  }
  const scaled = fontSize * relSz;
  return Number.isFinite(scaled) ? scaled : fontSize;
}
